"use client"

import { useState, useEffect } from "react"
import { Route, Redirect } from "react-router-dom"
import { CircularProgress, Container } from "@material-ui/core"
import firebase from "../firebase"

function PrivateRoute({ component: Component, ...rest }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      setIsAuthenticated(!!user)
    })

    return () => unsubscribe()
  }, [])

  if (isAuthenticated === null) {
    return (
      <Container style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Container>
    )
  }

  return <Route {...rest} render={(props) => (isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)} />
}

export default PrivateRoute

